module.exports = __webpack_public_path__ + "static/media/air-transmission.c64e89da.svg";